// can't find any usages of this filter - Travis 2021-03-03

angular.module('wbFilters').filter('missing', () => _.memoize(
  (input, predicate) => _.pick(_.cloneDeep(input), _.isNull),
  (input, predicate) => input[predicate]
));
